/** Чистка переменной, содержащей ошибку формы */
export const clearFormError = () => {
  window.error = "";
};
